import React, { useContext } from 'react';
import { Paragraph, tokens } from '@welbe/web-design-system';
import { RecommendedExams } from '../RecommendedExams/RecommendedExams';
import { ExpositionLevel } from '../ExpositionLevel/ExpositionLevel';
import { BiologicalAgent } from '../BiologicalAgent/BiologicalAgent';
import { ElementsWrapper, Hr } from './FormElements.styles';
import { Result } from '../Result/Result';
import {
	ElementsProps,
	ExamProps,
	JobProfileRiskFactorProps,
	StepProps,
} from '../../FormRisk.types';
import { UploadFile } from '../UploadFile/UploadFile';
import { JobProfileContext } from 'Views/JobProfile/JobProfile.context';
import { JobProfileType } from 'Views/JobProfile/JobProfile.enums';
import { RiskConditions } from '../RiskConditions/RiskConditions';

type FormElementsProps = {
	steps: StepProps[];
	riskFormsTypes: ElementsProps[];
	jobRiskFactor: {
		recommendedExams: ExamProps[];
		jobProfileRiskFactor: JobProfileRiskFactorProps;
	};
};

export const FormElements = ({
	steps,
	riskFormsTypes,
	jobRiskFactor,
}: FormElementsProps) => {
	const { jobProfileType, jobRiskFactors, focusedId } =
		useContext(JobProfileContext);

	const index = jobRiskFactors.findIndex(
		(item) => item.jobProfileRiskFactor.id === focusedId,
	);

	const canShowElement = (riskType: ElementsProps) => {
		return riskFormsTypes.includes(riskType);
	};

	return (
		<div>
			<Paragraph
				padding="15px 40px"
				fontSize="18px"
				fontWeight="400"
				color={tokens.color_primary}
			>
				{jobRiskFactors[index]?.name}
			</Paragraph>
			<Hr />
			<ElementsWrapper>
				{canShowElement('expositionLevel') &&
					jobProfileType === JobProfileType.RISK_PROFILE && <ExpositionLevel />}
				{canShowElement('expositionLevelArea') &&
					jobProfileType === JobProfileType.EXPOSITION_AREA && <UploadFile />}
				{canShowElement('biologicalAgent') && <BiologicalAgent />}
				{canShowElement('result') && <Result />}
				{canShowElement('recommendedExams') && (
					<RecommendedExams
						steps={steps}
						recommended={jobRiskFactor?.recommendedExams}
					/>
				)}
				{canShowElement('riskConditions') &&
					jobProfileType === JobProfileType.EXPOSITION_AREA && (
						<RiskConditions />
					)}
			</ElementsWrapper>
		</div>
	);
};
